export default __webpack_public_path__ + "media/images/app-icon-34d36fb1ab9addf73636f50572a621ff.svg";